import { linesResponseSchema, type Line } from '@chatapp-inbox/shared';
import { request } from './http';

/**
 * Os números de WhatsApp LIGADOS (qualquer usuário pode ver). A interface usa para mostrar em que
 * número a conversa acontece; é informação de apoio, então quem chama tolera a falha.
 */
export async function listLines(signal?: AbortSignal): Promise<Line[]> {
  const { lines } = await request('/lines', {
    schema: linesResponseSchema,
    ...(signal ? { signal } : {}),
  });
  return lines;
}
